// extracted by mini-css-extract-plugin
export default {"formSection":"ContactForm_formSection__9ku0g","form":"ContactForm_form__8tXlY","double":"ContactForm_double__Mfh-A"};